import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import Form from "./Form";
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, childrenNode, reactifiedChildrenPromise, headerNode, footerNode, footerPromise, headerPromise, reactifiedChildren, footer, header, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = getClassNameFactory("Form");
            childrenNode = domNode.querySelector("[data-rehydratable-children]");
            reactifiedChildrenPromise = rehydrateChildren(childrenNode);
            headerNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "header"
            })));
            footerNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "footer"
            })));
            footerPromise = footerNode ? rehydrateChildren(footerNode) : Promise.resolve(null);
            headerPromise = headerNode ? rehydrateChildren(headerNode) : Promise.resolve(null); // Ensure that all 3 rehydrateChildren calls can run in parallel, by
            // only awaiting _after_ the rehydrateChildren process has started.

            _context.next = 9;
            return reactifiedChildrenPromise;

          case 9:
            reactifiedChildren = _context.sent;
            _context.next = 12;
            return footerPromise;

          case 12:
            footer = _context.sent;
            _context.next = 15;
            return headerPromise;

          case 15:
            header = _context.sent;
            props = {
              isRehydrating: true,
              action: domNode.getAttribute("data-action"),
              id: domNode.getAttribute("data-id"),
              formName: domNode.getAttribute("data-form-name"),
              analyticsName: domNode.getAttribute("data-analytics-name"),
              analyticsType: domNode.getAttribute("data-analytics-type"),
              ajax: domNode.getAttribute("data-ajax") === "true",
              footer: footer,
              header: header,
              submitButtonText: domNode.getAttribute("data-submit-button-text"),
              hasRedirect: domNode.getAttribute("data-has-redirect") === "true",
              redirectPage: domNode.getAttribute("data-redirect-page"),
              formResource: domNode.getAttribute("data-form-resource"),
              messageType: domNode.getAttribute("data-message-type"),
              inlineMessage: domNode.getAttribute("data-inline-message"),
              endpoint: domNode.getAttribute("data-endpoint"),
              elqId: domNode.getAttribute("data-elq-id"),
              recaptchaSiteKey: domNode.getAttribute("data-recaptcha-site-key"),
              recaptchaApiKey: domNode.getAttribute("data-recaptcha-api-key"),
              isChiliPiperEnabled: domNode.getAttribute("data-is-chili-piper-enabled") === "true",
              chiliPiperRouterId: domNode.getAttribute("data-chili-piper-router-id")
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(Form, props, reactifiedChildren));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();